import getById from 'utils/DOM/getById'
import toggleClass from 'utils/DOM/toggleClass'
import getMaxPolicies from 'utils/pivot/plan/getMaxPolicies'
import getExtendDuration from 'utils/pivot/plan/getExtendDuration'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import getAdditionalInfo from 'sites/enroll.pivothealth.com/add-ons/getAdditionalInfo'
import { renderPlans } from 'sites/pivothealth.com/short-term-health-insurance/consumer/quotes/utils/renderPlans'
import getExtendedTagMessage from 'utils/pivot/plan/getExtendedTagMessage'
import getGenericPlanBenefits from 'utils/pivot/plan/getGenericPlanBenefits'
import renderMembersSection from './renderMembersSection'
import store from 'utils/store/withMiddleware'
import getTemplate from 'sites/enroll.pivothealth.com/quotes/utils/getTemplate'
import registryListenersDOMISC from '../registryListenersDOMISC'

const templatePlan = getTemplate('template-plan')
const plansWrap = getById('plans-wrap')

async function renderISCStyle(state) {
  const { planId, plan, period } = state
  state.plansToCompare = []
  state.plansVisited = []

  const { hasDentalActive, hasVisionActive } = await getAdditionalInfo(state)

  store.update({ hasDentalActive, hasVisionActive })

  renderPlans(plansWrap, templatePlan, { ...state, hasDentalActive, hasVisionActive }, [
    planId
  ])

  // Attach core benefits
  const coreDetailsTemplate = Templater(getById('isc-plan-benefit-template').innerText)
  const pointerNode = getById('plan__feature-list')

  const extendedDuration = getExtendDuration(plan, period)

  const { policies } = getMaxPolicies(plan, period)

  const durationLabel = getExtendedTagMessage({
    period,
    extendedDuration,
    currentPolicy: state.filters.policies,
    maxPolicies: policies
  })

  const benefits = [
    ...getGenericPlanBenefits(plan),
    {
      key: 'duration',
      value: `${durationLabel} days`,
      title: 'Duration',
      cssClass: 'pl-lg-6'
    }
  ]
  pointerNode.innerHTML = benefits
    .map(benefit => coreDetailsTemplate({ ...benefit, cssClass: benefit.cssClass ?? '' }))
    .join('')

  registryListenersDOMISC()
  renderMembersSection(state.hcStorage)
  toggleClass('#plans-wrap', 'd-none', false)
}

export default renderISCStyle
